// src/routes-config.js

// === Services (root-level paths) ===
export const servicesRoutes = [
    { path: "/artificial-intelligence", pageName: "ai" },
    { path: "/web-app", pageName: "web-development" },
    { path: "/blockchain-app", pageName: "blockchain-app" },
    { path: "/cloud-strategy", pageName: "cloud" },
    { path: "/robotic-process-automation", pageName: "robotic-automation" },
    { path: "/devops", pageName: "devops" },
    { path: "/ui-ux-services", pageName: "ui-ux" },
    { path: "/mobile-app", pageName: "mobile-app" },
    { path: "/software-testing", pageName: "software-testing" },
    { path: "/analytics", pageName: "analytics" },
];

// === Solutions (root-level paths) ===
export const solutionsRoutes = [
    { path: "/hospitality", pageName: "hospitality" },
    { path: "/healthcare", pageName: "healthcare" },
    { path: "/e-commerce", pageName: "ecommerce" },
    { path: "/fintech", pageName: "fintech" },
    { path: "/gps-tracking", pageName: "gpsTracking" },
    { path: "/real-estate", pageName: "realEstate" },
    { path: "/education", pageName: "education" },
    { path: "/erp-solutions", pageName: "erpSolutions" },
];

// === Hire Team (root-level paths) ===
export const hireTeamRoutes = [
    { path: "/hire-reactjs-developer", pageName: "reactjs-developer" },
    { path: "/hire-angularjs-developer", pageName: "angularjs-developer" },
    { path: "/hire-nodejs-developer", pageName: "nodejs-developer" },
    { path: "/hire-vuejs-developer", pageName: "vuejs-developer" },
    { path: "/hire-uiux-developer", pageName: "uiux-developer" },
    { path: "/hire-golang-developer", pageName: "golang-developer" },
    { path: "/hire-aspnet-developer", pageName: "aspnet-developer" },
    { path: "/hire-java-developer", pageName: "java-developer" },
    { path: "/hire-python-developer", pageName: "python-developer" },
    { path: "/hire-php-developer", pageName: "php-developer" },
    { path: "/hire-flutter-developer", pageName: "flutter-developer" },
    { path: "/hire-ionic-developer", pageName: "ionic-developer" },
    { path: "/hire-ios-developer", pageName: "ios-developer" },
    { path: "/hire-android-developer", pageName: "android-developer" },
    { path: "/hire-rpa-developer", pageName: "rpa-developer" },
    { path: "/hire-ml-developer", pageName: "ml-developer" },
    { path: "/hire-devops-developer", pageName: "devops-developer" },
    { path: "/hire-powerbi-developer", pageName: "powerbi-developer" },
    { path: "/hire-awscloud-developer", pageName: "awscloud-developer" },
    { path: "/hire-azurecloud-developer", pageName: "azurecloud-developer" },
    { path: "/hire-htmlcss-developer", pageName: "htmlcss-developer" },
    { path: "/hire-laravel-developer", pageName: "laravel-developer" },
    { path: "/hire-dotnetcore-developer", pageName: "dotnetcore-developer" },
    { path: "/hire-django-developer", pageName: "django-developer" },
    { path: "/hire-csharp-developer", pageName: "csharp-developer" },
    { path: "/hire-data-scientist", pageName: "data-scientist" },
    { path: "/hire-data-engineer", pageName: "data-engineer" },
    { path: "/hire-ai-developer", pageName: "ai-developer" },
    { path: "/hire-chatgpt-developer", pageName: "chatgpt-developer" },
    { path: "/hire-openai-developer", pageName: "openai-developer" },
    { path: "/hire-prompt-engineer", pageName: "prompt-engineer" },
    { path: "/hire-aiops-engineer", pageName: "aiops-engineer" },
    { path: "/hire-moodle-developer", pageName: "moodle-developer" },
    { path: "/hire-hubspot-developer", pageName: "hubspot-developer" },
    { path: "/hire-unity-developer", pageName: "unity-developer" },
    { path: "/hire-reactnative-developer", pageName: "reactnative-developer" },
    { path: "/hire-wix-developer", pageName: "wix-developer" },
    { path: "/hire-dibol-developer", pageName: "dibol-developer" },
    { path: "/hire-fortran-developer", pageName: "fortran-developer" },
    { path: "/hire-cybersecurity-developer", pageName: "cybersecurity-developer" },
    { path: "/hire-frontend-developer", pageName: "frontend-developer" },
    { path: "/hire-backend-developer", pageName: "backend-developer" },
    { path: "/hire-mobile-app-developer", pageName: "mobile-app-developer" },
];

// === Portfolio (root-level paths under /portfolio/slug) ===
export const portfolioRoutes = [
    { path: "/portfolio/rxnt", pageName: "rxnt" },
    { path: "/portfolio/frank", pageName: "frank" },
    { path: "/portfolio/svhs", pageName: "svhs" },
    { path: "/portfolio/tds", pageName: "tds" },
    { path: "/portfolio/tynax", pageName: "tynax" },
    { path: "/portfolio/anatomie", pageName: "anatomie" },
    { path: "/portfolio/vacsewcenter", pageName: "vacsewcenter" },
    { path: "/portfolio/wbes", pageName: "wbes" },
    { path: "/portfolio/openn", pageName: "openn" },
    { path: "/portfolio/willship", pageName: "willship" },
];
